<!-- Autoplay notification - appears when browser blocks autoplay -->
@if (isAutoplayBlocked()) {
  <div class="autoplay-notification">
    <div class="notification-content">
      <div class="notification-icon">🔊</div>
      <div class="notification-text">
        <strong>Waiting for interaction</strong>
        <p>Click anywhere or adjust volume to start audio playback</p>
      </div>
    </div>
  </div>
}

<!-- Player controls row (centered) -->
<div class="player-row controls-row !m-0">
  <div class="player-controls">
    <button (click)="onPlayPrevious()"
            [disabled]="!canPlayPrevious()"
            class="control-button prev-button">
      <svg fill="none" height="20" stroke="currentColor" stroke-linecap="round" stroke-linejoin="round"
           stroke-width="2" viewBox="0 0 24 24" width="20" xmlns="http://www.w3.org/2000/svg">
        <line x1="19" x2="5" y1="12" y2="12"></line>
        <polyline points="12 19 5 12 12 5"></polyline>
      </svg>
    </button>

    <!-- Play/Pause button that transforms into a loading indicator when audio is loading -->
    <button (click)="onTogglePlayPause()"
            [class.loading]="isLoading()"
            class="control-button play-pause">
      @if (isLoading()) {
        <div class="button-loader">
          <div class="loading-spinner"></div>
        </div>
      } @else {
        @if (isPlaying()) {
          <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none"
               stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
            <rect x="6" y="4" width="4" height="16"></rect>
            <rect x="14" y="4" width="4" height="16"></rect>
          </svg>
        } @else {
          <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none"
               stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
            <polygon points="5 3 19 12 5 21 5 3"></polygon>
          </svg>
        }
      }
    </button>

    <button (click)="onPlayNext()"
            [disabled]="!canPlayNext()"
            class="control-button next-button">
      <svg fill="none" height="20" stroke="currentColor" stroke-linecap="round" stroke-linejoin="round"
           stroke-width="2" viewBox="0 0 24 24" width="20" xmlns="http://www.w3.org/2000/svg">
        <line x1="5" x2="19" y1="12" y2="12"></line>
        <polyline points="12 5 19 12 12 19"></polyline>
      </svg>
    </button>
  </div>

  <div class="track-counter">
    {{ trackCounterText() }}
  </div>
</div>

<!-- Volume control and track counter in one row at bottom -->
<div class="player-row bottom-row">
  <div class="timer-display">
    <div class="timer-icon">
      <svg fill="none" height="18" stroke="currentColor" stroke-linecap="round" stroke-linejoin="round"
           stroke-width="2" viewBox="0 0 24 24" width="18" xmlns="http://www.w3.org/2000/svg">
        <circle cx="12" cy="12" r="10"></circle>
        <polyline points="12 6 12 12 16 14"></polyline>
      </svg>
    </div>
    <div class="timer-progress">
      <span class="current-time">{{ formatTime(calculateCurrentRelativeTime()) }}</span>
      <span class="separator"> / </span>
      <span class="total-time">{{ formatSectionDuration() }}</span>
    </div>
  </div>

  <div class="volume-control">
    <div class="volume-icon">
      <svg fill="none" height="20" stroke="currentColor" stroke-width="2" viewBox="0 0 24 24" width="20">
        <polygon points="11 5 6 9 2 9 2 15 6 15 11 19 11 5"/>
        <path d="M15.54 8.46a5 5 0 0 1 0 7.07"/>
        <path d="M19.07 4.93a10 10 0 0 1 0 14.14"/>
      </svg>
    </div>
    <input (input)="updateVolume($event)"
           (mouseup)="onVolumeSliderEnd()"
           (touchend)="onVolumeSliderEnd()"
           [value]="displayVolume()"
           class="volume-slider"
           max="1"
           min="0"
           step="0.01"
           type="range">
    <div class="volume-level">{{ volumeDisplay() }}</div>
  </div>
</div>
